import React, { ReactElement } from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ControlledSelect } from '../../../../../components';
import { SelectOption } from '../../../../../components/CiscoUi';

export type TemplateVisibilityDropDownProps = {
  name: string;
  options: SelectOption<string>[];
  defaultValue: string;
  control: Control;
};

export const TemplateVisibilityDropDown = ({
  options,
  defaultValue,
  name,
  control,
}: TemplateVisibilityDropDownProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <ControlledSelect
      control={control}
      options={options}
      defaultValue={defaultValue}
      name={name}
      label={t('templateManager.demoTemplates.form.labels.visibility')}
      labelClass="col-3"
    />
  );
};
